// extracted by mini-css-extract-plugin
export var alertIcon = "_ms-0";